var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "aceEditor--main" }, [
    _c("div", { staticClass: "aceEditor--topbar" }, [
      _vm.showThemeToggle
        ? _c("div", { staticClass: "aceEditor--subcontainer" }, [
            _c(
              "button",
              {
                staticClass: "btn btn-xs btn-default",
                on: { click: _vm.toggleDarkMode }
              },
              [_vm._v(" " + _vm._s(_vm._f("translate")("Toggle dark mode")))]
            )
          ])
        : _vm._e(),
      _vm.showLangSelector
        ? _c("div", { staticClass: "aceEditor--subcontainer" }, [
            _c(
              "select",
              {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.lang,
                    expression: "lang"
                  }
                ],
                staticClass: "aceEditor--langselect",
                on: {
                  change: function($event) {
                    var $$selectedVal = Array.prototype.filter
                      .call($event.target.options, function(o) {
                        return o.selected
                      })
                      .map(function(o) {
                        var val = "_value" in o ? o._value : o.value
                        return val
                      })
                    _vm.lang = $event.target.multiple
                      ? $$selectedVal
                      : $$selectedVal[0]
                  }
                }
              },
              [
                _c("option", { attrs: { value: "html" } }, [_vm._v("HTML")]),
                _c("option", { attrs: { value: "javascript" } }, [
                  _vm._v("JavaScript")
                ]),
                _c("option", { attrs: { value: "css" } }, [_vm._v("CSS")])
              ]
            )
          ])
        : _vm._e()
    ]),
    _c("div", { staticClass: "aceEditor--editor", attrs: { id: _vm.thisId } })
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }